module.exports = __webpack_public_path__ + "static/media/52961886_2452972804777896_6573993100648120320_o.0a1dc609.jpg";